// MiniSessionBanner.js — the one-line session strip shown while the chat
// overlay owns the panel: same minimal language as the collapsed rail
// (patient name + pulsing red dot per recording visit). Tap a chip to
// open that patient; the full timeline returns when the chat dismisses.
import React from 'react';
import { useComprehendLive } from 'agent/useComprehendLive';
import { T, pill } from './liveTheme';

const MiniSessionBanner = () => {
  const { state, actions } = useComprehendLive();
  const recording = state.sessions.filter((s) => s.recording);

  return (
    <div
      className="cpl-rail"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '0 12px 6px',
        overflowX: 'auto',
        minWidth: 0,
        maxWidth: '100%',
        flexShrink: 0,
      }}
    >
      {recording.length === 0 && (
        <span style={{ color: T.textFaint, fontSize: 11 }}>
          No visits recording
        </span>
      )}
      {recording.map((s) => (
        <span
          key={s.conversationId}
          onClick={() => actions.openDrillIn(s.conversationId)}
          role="button"
          style={{
            ...pill('rgba(245,54,92,0.14)', T.redSoft),
            border: '1px solid rgba(245,54,92,0.4)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          <span
            className="cpl-dot"
            style={{ background: T.red, width: 7, height: 7 }}
          />
          <span style={{ color: T.textPrimary }}>{s.patientName}</span>
        </span>
      ))}
    </div>
  );
};

export default MiniSessionBanner;
